import React, { useEffect, useState } from "react";
import StaticFooter from "../../staticpagis/StaticFooter";
import { Col, FormLabel, Row, Form } from "react-bootstrap";
import { InputField } from "../../sharedComponents/InputField";
import TextArea from "antd/es/input/TextArea";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import { SharedButton } from "../../sharedComponents/Button";
import StaticNav from "./StaticNav";
import { business_location_update, get_business_location_detail } from "../../Studio-Services/Studio_Services";
import { errorAlert } from "../../Static_Services/Alertmsg";
import Swal from "sweetalert2";
import logo from '../../Images/logo_white_web.png';
import { useLocation, useNavigate } from "react-router-dom";

export default function BusinessLocation() {

  const [locationArray, setLocationArray] = useState([{
    "id": 1, "location_id": null, "location_name": '', "location_url": '', "capacity": '',
    "is_address_same": 'Yes', "address": ''
  }]);
  const [currentUser, setCurrentUser] = useState();
  const [business_address, setBusiness_address] = useState();
  const [isLocationExist, setIsLocationExist] = useState(false);
  const [buisnessData, setBuisnessData] = useState();
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    const getcurrentUser = (localStorage.getItem('st_userData')) ? JSON.parse(localStorage.getItem('st_userData')) : JSON.parse(localStorage.getItem('st_userRegisterData'));
   
    setCurrentUser(getcurrentUser);
    if (localStorage.getItem('st_businessPrfoileData')) {
      const getbuisnessData = JSON.parse(localStorage.getItem('st_businessPrfoileData'));
      setBuisnessData(JSON.parse(localStorage.getItem('st_businessPrfoileData')));
      setBusiness_address(getbuisnessData.address);
    }
  }, [location]);


  useEffect(() => {
    if (currentUser && currentUser.business_id) {
      getBusinessLocation();
    }
    if (currentUser && !currentUser.business_id) {
      onChange('Yes', '0');
    }
  }, []);

  const onChange = (deviceValue, index) => {
    if (deviceValue == 'Yes') {
      let newlocationArray = [...locationArray];
      newlocationArray[index].address = buisnessData.address;
      setLocationArray(newlocationArray);
    } else if (deviceValue == 'No') {
      let newlocationArray = [...locationArray];
      newlocationArray[index].address = '';
      setLocationArray(newlocationArray);
    }
  }

  const getBusinessLocation = async () => {
    const data = { 'business_id': currentUser.business_id };
    const resp = await get_business_location_detail(data);
    if (resp) {
      const buisnessData = resp.data.data;
      setBusiness_address(buisnessData.address);
      setLocationArray(buisnessData.location_info);
      setIsLocationExist(true);
    }

  }

  const addMoreLocation = () => {
    let newLocationArray = [...locationArray];

    // Push a new object into the copy
    newLocationArray.push({
      id: newLocationArray.length + 1,
      location_id: null,
      location_name: '',
      location_url: '',
      capacity: '',
      is_address_same: 'Yes',
      address: ''
    });

    // Update the original locationArray
    setLocationArray(newLocationArray);
  }

  const removeMoreLocation = (index) => {
    let newLocationArray = [...locationArray];
    newLocationArray.splice(index, 1);
    setLocationArray(newLocationArray);
  }

  const handleAddressChange = (address) => {
    let lattitude = address.geometry.location.lat();
    let longitude = address.geometry.location.lng();
    let other_address = address.formatted_address;
    let street = address.name;
  }


  const handleChange = (e, index) => {
    let { name, value } = e.target;
    let newlocationArray = [...locationArray];
    newlocationArray[index][name] = value;
    setLocationArray(newlocationArray);
  }

  const setBusinesslocation = async () => {
    let isValid = 1;
    let collection = [];

    for (var i = 0; i < locationArray.length; i++) {
      if (locationArray[i].location_name == '' || locationArray[i].capacity == '') {
        return;
      }
      let rowObject = locationArray[i];
      let location_url = rowObject.location_url;
      if (!location_url.match(/^[a-zA-Z]+:\/\//) && location_url.length > 0) {
        locationArray.location_url = 'http://' + location_url;
      }
      if (locationArray.is_address_same == 'No') {
        if (!('longitude' in rowObject)) {
          errorAlert('Please enter proper address.');
          return false;
        }
      }
      // collection.push(rowObject);
    }

    if (isValid === 1) {
      let businessID='';
      if(buisnessData && buisnessData.business_id){
        businessID=buisnessData.business_id;
      }else{
        businessID=currentUser.business_id;
      }

      let data = {
        "user_id": currentUser.id,
        "business_id": businessID,
        "business_address": business_address,
        "location_info": locationArray
      }
      const resp = await business_location_update(data);
      if(resp){
        Swal.fire({
          html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-uppercase text-center mt-4 textWhite">
          SUCCESS
        </h4>
        <p class="text-center my-4 textcolor">
        <small class="textWhite">
       ${resp.data.message} </small></p>
        `,
          showClass: {
            popup: 'custom-dialog-container',
          },
          customClass: {
            confirmButton: 'custom-button custom-button-size modalbtn',
          },
          confirmButtonText: 'Continue',
        }).then((result) => {
          if (result.isConfirmed) {
              navigate('/business-hours');
            }
        });
      }
    }
  }



  return (
    <>
      <StaticNav />
      <section className="Location-container">
        <div className="background-before">
          <div className="py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="pricing-studio text-center wow animated slideInLeft mb-0">
                    <h2 className="dark-color font-w-500 pb-0 text-left">
                      Complete Your Location Details
                    </h2>
                    <p className="text-left m-0">Location details include information about where you will hold your classes or workshops such as the name of a room or additional you may provide your activities</p>
                  </div>
                  <div className="login-boxs border-radius10 p-4">
                    <h5 className="text-left m-0 text-capital pb-3">
                      Room For Your Activitys
                    </h5>
                    <Row>
                      <Col md={8}>
                        <FormLabel className="form-label inputLable">Head Quaters Address</FormLabel>
                        <TextArea value={business_address} readOnly />
                      </Col>
                      <Col md={4}></Col>
                    </Row>
                    {locationArray.map((location, index) => (
                      <div key={index} className="roomactivitybox">
                        <Row className="mt-3 mb-3">
                          <Col md={3}>
                            <InputField lable={"Room Name"} type={"text"} name="location_name" value={location.location_name} onChange={(e) => handleChange(e, index)} />
                          </Col>
                          <Col md={4}>
                            <InputField lable={"Web Link"} type={"text"} name="location_url" value={location.location_url} onChange={(e) => handleChange(e, index)} />
                          </Col>
                          <Col md={2}>
                            <InputField lable={"Capacity"} type={"number"} name="capacity" value={location.capacity} onChange={(e) => handleChange(e, index)} />
                          </Col>
                          <Col md={3}>
                            <div className="form-label inputLable">
                              <label>Address (same as Head Quarters)</label>
                              <select
                                className="form-control"
                                name="is_address_same"
                                value={location.is_address_same}
                                onChange={(e) => handleChange(e, index)}
                              >
                                <option selected={location.is_address_same === "Yes"} value="Yes">Yes</option>
                                <option selected={location.is_address_same === "no"} value="No">No</option>
                              </select>
                            </div>
                          </Col>

                        </Row>
                        {locationArray.length > 1 && (
                          <AiFillMinusCircle
                            onClick={() => removeMoreLocation(index)}
                            style={{ cursor: "pointer" }}
                            className="HoursModalPlusred"
                          />
                        )}
                      </div>

                    ))}

                    <AiFillPlusCircle onClick={addMoreLocation} className="HoursModalPlus" />
                    <Row className="pt-3 pb-3">
                      <Col>
                        <SharedButton title={'Save & Continue'} onClick={setBusinesslocation} className={'btn'} type={'button'} variant="primary" />
                        <SharedButton title={'cancel'} className={'btn cancel'} type={'button'} variant="outline" />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <StaticFooter />
    </>
  );
}
